/**
 * Contrast between colours, as WCAG measures it.
 */

// Relative luminance of a #RRGGBB colour, 0 (black) to 1 (white). Null when
// the value is not a six-digit hex.
export function luminance(hex) {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex || '');
  if (!m) return null;
  const [r, g, b] = [0, 2, 4].map((i) => {
    const c = parseInt(m[1].slice(i, i + 2), 16) / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

// The contrast ratio of two hex colours, 1 to 21.
export function contrastRatio(a, b) {
  const la = luminance(a);
  const lb = luminance(b);
  if (la == null || lb == null) return null;
  return (Math.max(la, lb) + 0.05) / (Math.min(la, lb) + 0.05);
}

export const DARK_INK = '#0B0F19';

/**
 * The text colour to put on a background: white or a near-black ink,
 * whichever reads better. Several colours (a gradient's stops) are judged by
 * the worst of them, since the text crosses all of them. Colours that are not
 * a hex are ignored; with none left, white.
 */
export function readableInk(...backgrounds) {
  const worst = (ink) => Math.min(...backgrounds
    .map((bg) => contrastRatio(ink, bg))
    .filter((r) => r != null));
  const white = worst('#FFFFFF');
  const dark = worst(DARK_INK);
  if (!Number.isFinite(white)) return 'white';
  return dark > white ? DARK_INK : 'white';
}
